import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveDirective as _resolveDirective, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28d72497"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-dark bg-dark navbar-expand-lg" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "nav-collapse",
  ref: "navbarEl"
}
const _hoisted_6 = { class: "navbar-nav" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_13 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_14 = { class: "nav-item ms-1" }
const _hoisted_15 = {
  class: "nav-link social",
  href: "https://www.youtube.com/MouseHatGames?sub_confirmation=1",
  target: "_blank",
  title: "YouTube"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 d-lg-none d-inline" }, "YouTube", -1))
const _hoisted_17 = { class: "nav-item ms-1" }
const _hoisted_18 = {
  class: "nav-link social",
  href: "https://twitter.com/LogicWorldGame",
  target: "_blank",
  title: "Twitter"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 d-lg-none d-inline" }, "Twitter", -1))
const _hoisted_20 = { class: "nav-item ms-1" }
const _hoisted_21 = {
  class: "nav-link social",
  href: "https://discord.gg/C5Qkk53",
  target: "_blank",
  title: "Discord"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 d-lg-none d-inline" }, "Discord", -1))
const _hoisted_23 = { class: "d-flex ms-3" }
const _hoisted_24 = { class: "input-group" }
const _hoisted_25 = { class: "navbar-nav ms-auto" }
const _hoisted_26 = { class: "nav-item me-2" }
const _hoisted_27 = { class: "nav-item dropdown" }
const _hoisted_28 = {
  class: "nav-link dropdown-toggle p-0",
  id: "userDropdown",
  href: "#",
  role: "button"
}
const _hoisted_29 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "userDropdown"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "nav-item" }
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_icon = _resolveComponent("icon")
  const _directive_tooltip = _resolveDirective("tooltip")
  const _directive_dropdown = _resolveDirective("dropdown")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-container", {fixed: $setup.fixedNavbar}])
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: "/",
        "aria-label": "Homepage"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: $setup.endpoints.asset('img/logo_white.svg'),
            width: "105",
            height: "40",
            alt: "Logic World logo"
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        onClick: _cache[0] || (_cache[0] = $event => ($setup.collapse?.toggle())),
        "aria-controls": "nav-collapse",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/forums"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Forums")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/hub"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Creation hub")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/newsletter"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Newsletter")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/wishlist"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Buy now")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/tracker"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Issue tracker")
              ]),
              _: 1
            })
          ]),
          ($setup.hasFlag('can-access-adminpanel'))
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: "/admin"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Admin panel")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          ($setup.canAccessManagement)
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: {name:'manpanelIndex'}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Management")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_14, [
            _createElementVNode("a", _hoisted_15, [
              _createVNode(_component_icon, {
                icon: ['fab', 'youtube'],
                "fixed-width": "fixed-width"
              }),
              _hoisted_16
            ])
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createElementVNode("a", _hoisted_18, [
              _createVNode(_component_icon, {
                icon: ['fab', 'twitter'],
                "fixed-width": "fixed-width"
              }),
              _hoisted_19
            ])
          ]),
          _createElementVNode("li", _hoisted_20, [
            _createElementVNode("a", _hoisted_21, [
              _createVNode(_component_icon, {
                icon: ['fab', 'discord'],
                "fixed-width": "fixed-width"
              }),
              _hoisted_22
            ])
          ]),
          _createElementVNode("li", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "search",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.searchQuery) = $event)),
                onKeypress: _withKeys($setup.goSearch, ["enter"]),
                placeholder: "Search",
                "aria-label": "Search"
              }, null, 544), [
                [_vModelText, $setup.searchQuery]
              ]),
              (!$setup.isSearchEmpty)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-primary",
                    type: "submit",
                    onClick: $setup.goSearch
                  }, "Search"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("ul", _hoisted_25, [
          ($setup.currentUser)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("li", _hoisted_26, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    href: "#",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => $setup.toggleNotifsModal(), ["prevent"]))
                  }, [
                    _createVNode(_component_icon, {
                      class: "bell",
                      icon: "bell"
                    })
                  ])
                ]),
                _createElementVNode("li", _hoisted_27, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_28, [
                    _withDirectives(_createVNode($setup["UserPicture"], { user: $setup.currentUser }, null, 8, ["user"]), [
                      [_directive_tooltip, '@' + $setup.currentUser.username]
                    ])
                  ])), [
                    [_directive_dropdown]
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      href: $setup.endpoints.auth('settings')
                    }, "Account settings", 8, _hoisted_30),
                    _createVNode(_component_router_link, {
                      class: "dropdown-item",
                      to: {name:'siteSettings'}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Site settings")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      class: "dropdown-item",
                      to: {name:'userPage', params: { name: $setup.currentUser.username }}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("View profile")
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _hoisted_31,
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      href: $setup.endpoints.auth('logout', $setup.currentURL)
                    }, "Log out", 8, _hoisted_32)
                  ])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("li", _hoisted_33, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    href: $setup.endpoints.auth('register', $setup.currentURL)
                  }, [
                    _createVNode(_component_icon, { icon: "user" }),
                    _createTextVNode(" Sign up")
                  ], 8, _hoisted_34)
                ]),
                _createElementVNode("li", _hoisted_35, [
                  _createElementVNode("a", {
                    class: "nav-link",
                    href: $setup.endpoints.auth('login', $setup.currentURL)
                  }, [
                    _createVNode(_component_icon, { icon: "sign-in-alt" }),
                    _createTextVNode(" Log in")
                  ], 8, _hoisted_36)
                ])
              ], 64))
        ])
      ], 512)
    ])
  ], 2))
}